export const API_URL = import.meta.env.DEV
  ? "https://hwwork.app/proxy/b1s/v2"
  : "/proxy/b1s/v2";

export const LOGIN_VERSION = 1.2;

export const TEST_DATABASE_NAME = "HWSERVICE_TEST";

export const SUPPORT_USER_ID = 12;
